/** German texts of the module, below its ID: `sifa.nav.inspections`. */
export const de = {
  name: 'SiFa',
  description:
    'Begehungen der Fachkraft für Arbeitssicherheit in Arbeitsstätten: Mängel mit Fotos, Allgemeine Angaben, Anwesende, Protokoll und Gefahrstoffsuche in GESTIS.',
  nav: { inspections: 'Begehungen', substances: 'Gefahrstoffe' },
  permissions: {
    inspection: {
      read: {
        label: 'Begehungen ansehen',
        description:
          'Begehungen mit Mängeln, Anhängen und Verlauf öffnen und Berichte erstellen. Mit Umfang „Eigene“ nur Begehungen, bei denen die Person Begeher ist oder die sie angelegt hat.',
      },
      write: {
        label: 'Begehungen bearbeiten',
        description:
          'Begehungen anlegen, ändern, starten, abschließen und wieder öffnen, Mängel mit Fotos und Anhänge erfassen. Mit Umfang „Eigene“ nur Begehungen, bei denen die Person Begeher ist oder die sie angelegt hat.',
      },
      delete: {
        label: 'Begehungen löschen',
        description: 'Begehungen mit Mängeln, Anhängen und Kommentaren löschen.',
      },
      comment: {
        label: 'Begehungen kommentieren',
        description: 'Kommentare an Begehungen schreiben.',
      },
      export: {
        label: 'Begehungen exportieren',
        description: 'Die Liste der Begehungen als CSV-Datei herunterladen.',
      },
    },
    substance: {
      search: {
        label: 'Gefahrstoffe suchen',
        description:
          'Stoffe in der GESTIS-Stoffdatenbank suchen. Die Suche läuft live, gespeichert wird nichts.',
      },
    },
    settings: {
      manage: {
        label: 'SiFa einrichten',
        description:
          'Mängelkatalog, Berichtsvorlagen, Fragebögen und Einstellungen pflegen, Ansichten der Begehungsliste für die Firma speichern.',
      },
    },
  },
  roles: {
    inspector: 'SiFa: Begehungen durchführen',
    manager: 'SiFa: Begehungen verwalten',
  },
  settings: {
    offlineDays: {
      label: 'Abgeschlossene Begehungen offline (Tage)',
      description:
        'So viele Tage nach „Protokoll versendet“ bleiben eigene Begehungen auf dem Gerät. Bei 0 nur laufende und geplante.',
    },
  },
  states: { planned: 'Geplant', 'in-progress': 'Laufend', completed: 'Abgeschlossen' },
  offline: { inspections: 'SiFa-Begehungen' },
  ai: { findingDraft: 'Mangel aus Stichpunkten formulieren' },
  questionnaires: { general: 'Allgemeine Angaben' },
  documents: {
    inspectionReport: 'SiFa-Begehungsprotokoll',
    groups: {
      project: 'Projekt',
      object: 'Objekt',
      customer: 'Kunde',
      inspection: 'Begehung',
      findings: 'Mängel',
    },
    placeholders: {
      project: { number: 'Projektnummer', title: 'Bezeichnung des Projekts' },
      object: {
        name: 'Name',
        number: 'Objektnummer',
        customerNumber: 'Objektnummer des Kunden',
        address: 'Adresse',
        street: 'Straße und Hausnummer',
        postalCode: 'PLZ',
        city: 'Ort',
        state: 'Bundesland',
        usage: 'Nutzung',
        buildingClass: 'Gebäudeklasse',
      },
      customer: {
        name: 'Name',
        number: 'Kundennummer',
        address: 'Adresse',
        phone: 'Telefon',
        email: 'E-Mail',
        website: 'Webseite',
        contact: 'Ansprechpartner',
      },
      inspection: {
        title: 'Bezeichnung',
        date: 'Datum',
        inspectors: 'Begeher',
        participants: 'Teilnehmer',
        attendees: 'Anwesende',
        status: 'Status',
        remarks: 'Bemerkungen',
      },
      findings: { count: 'Anzahl Mängel', open: 'Offene Mängel' },
    },
    sources: { attendees: 'Anwesende', remarks: 'Bemerkungen' },
    reportTitle: 'SiFa-Begehungsprotokoll {{title}} {{date}}',
    columns: { name: 'Name', role: 'Funktion' },
    checks: {
      unanswered: 'Allgemeine Angaben: {{count}} Fragen ohne Antwort.',
      attendees: 'Keine Anwesenden eingetragen.',
      remarks: 'Keine Bemerkungen eingetragen.',
    },
    sample: {
      title: 'Begehung 08.10.2026',
      project: 'Sicherheitstechnische Betreuung 2026',
      object: 'Werk Musterstadt',
      customer: 'Beispiel Metallbau GmbH',
      participants: 'Betriebsrat, Betriebsärztlicher Dienst',
      siteManager: 'Geschäftsführung',
      foreman: 'Sicherheitsbeauftragter',
      remarks: 'Werkstatt aufgeräumt, Fluchtwege frei.',
    },
  },
  audit: {
    inspection: {
      create: 'Begehung angelegt',
      update: 'Begehung geändert',
      start: 'Begehung gestartet',
      complete: 'Protokoll versendet',
      reopen: 'Begehung wieder geöffnet',
      delete: 'Begehung gelöscht',
    },
  },
  guides: {
    inspections: {
      title: 'SiFa-Begehungen',
      summary:
        'Begehungen von Arbeitsstätten planen, durchführen und abschließen, und wer was darf.',
    },
    substances: {
      title: 'Gefahrstoffe suchen',
      summary: 'Stoffe mit Datenblatt in GESTIS finden, ohne etwas zu speichern.',
    },
  },
  errors: {
    project: 'Bitte ein Projekt der eigenen Firma wählen.',
    projectArchived: 'Das Projekt ist archiviert. Bitte ein laufendes Projekt wählen.',
    object: 'Bitte ein Objekt des Projekts wählen, das nicht archiviert ist.',
    title: 'Bitte eine Bezeichnung eingeben (höchstens 200 Zeichen).',
    date: 'Bitte ein gültiges Datum eingeben.',
    status: 'Eine neue Begehung beginnt als geplant oder laufend.',
    inspector: 'Bitte aktive Konten der Firma als Begeher wählen.',
    tooManyInspectors: 'Eine Begehung hat höchstens 20 Begeher.',
    participants: 'Die Teilnehmer dürfen höchstens 2000 Zeichen lang sein.',
    attendeeName: 'Bitte einen Namen angeben (höchstens 200 Zeichen).',
    attendeeRole: 'Die Funktion darf höchstens 200 Zeichen lang sein.',
    tooManyAttendees: 'Eine Begehung hat höchstens 100 Anwesende.',
    remarks: 'Die Bemerkungen dürfen höchstens 20 000 Zeichen lang sein.',
    attachment: 'Anhänge müssen PDF-Dateien dieser Begehung sein, jede nur einmal.',
    attachmentTitle: 'Der Titel des Anhangs darf höchstens 200 Zeichen lang sein.',
    tooManyAttachments: 'Eine Begehung hat höchstens 50 Anhänge.',
  },
  substances: {
    title: 'Gefahrstoffe',
    description:
      'Stoffe in der GESTIS-Stoffdatenbank des Instituts für Arbeitsschutz der DGUV (IFA) suchen, mit Einstufung, Grenzwerten und Schutzmaßnahmen. Die Suche läuft live, die App speichert nichts.',
    query: 'Stoff',
    queryHint: 'Stoffname, CAS- oder EG-Nummer.',
    queryPlaceholder: 'z. B. Aceton oder 67-64-1',
    language: 'Sprache',
    languages: { de: 'Deutsch', en: 'Englisch' },
    search: 'Suchen',
    start: 'Suchbegriff eingeben',
    startHint: 'Gesucht wird in GESTIS, das Datenblatt öffnet dort.',
    offline: 'Ohne Verbindung geht die Suche nicht. Sie fragt GESTIS live ab.',
    notice:
      'GESTIS beschreibt reine Stoffe. Für ein Produkt maßgeblich ist das Sicherheitsdatenblatt des Lieferanten (§ 6 Abs. 2 GefStoffV). Die App sendet nur den Suchbegriff, keine Namen.',
    newTab: '(öffnet in neuem Tab)',
    results: 'Stoffe in GESTIS',
    resultsHint: 'Höchstens 25 Treffer.',
    name: 'Stoff',
    cas: 'CAS-Nummer',
    open: 'Datenblatt öffnen',
    none: 'Kein Stoff gefunden',
    noneHint: 'Anderen Namen oder die CAS-Nummer versuchen.',
    errors: {
      tooShort: 'Bitte mindestens zwei Zeichen eingeben.',
      invalid: 'Bitte den Suchbegriff prüfen.',
      busy: 'Zu viele Suchen in kurzer Zeit. Bitte eine Minute warten.',
      unavailable: 'GESTIS antwortet gerade nicht. Bitte später erneut suchen.',
      forbidden: 'Dafür fehlt die Berechtigung.',
    },
  },
  sections: { inspections: 'SiFa-Begehungen' },
  pages: {
    unavailable: 'nicht verfügbar',
    offlinePerson: 'Name nur mit Verbindung',
    errors: {
      versionConflict:
        'Die Begehung wurde inzwischen geändert. Die Seite zeigt jetzt den neuen Stand; bitte die Änderung wiederholen.',
      completed: 'Das Protokoll ist versendet. Erst nach „Wieder öffnen“ lässt sich etwas ändern.',
      status: 'Dieser Schritt passt nicht zum Status der Begehung. Bitte die Seite neu laden.',
      invalidInput: 'Bitte die Angaben prüfen.',
      notFound: 'Die Begehung gibt es nicht mehr.',
      forbidden: 'Dafür fehlt die Berechtigung.',
    },
    list: {
      title: 'Begehungen',
      description: 'SiFa-Begehungen an den betreuten Betriebsstätten.',
      search: 'Begehungen durchsuchen',
      searchPlaceholder: 'Bezeichnung, Projekt oder Objekt',
      exportName: 'SiFa-Begehungen',
      offline: 'Ohne Verbindung: Begehungen auf diesem Gerät',
      allStatuses: 'Alle Status',
      allProjects: 'Alle Projekte',
      allObjects: 'Alle Objekte',
      allInspectors: 'Alle Begeher',
      from: 'Datum von',
      to: 'Datum bis',
      noMatches: 'Keine passenden Begehungen',
      noMatchesHint: 'Suche oder Filter ändern.',
      empty: 'Noch keine Begehungen',
      emptyHint: 'Mit „Begehung starten“ die erste Begehung anlegen.',
      emptyReadOnly: 'Angelegte Begehungen erscheinen hier.',
      findings: '{{open}} / {{total}}',
      columns: {
        title: 'Bezeichnung',
        status: 'Status',
        project: 'Projekt',
        object: 'Objekt',
        date: 'Datum',
        inspectors: 'Begeher',
        findings: 'Mängel offen / gesamt',
      },
    },
    section: {
      date: 'Datum',
      title: 'Bezeichnung',
      object: 'Objekt',
      status: 'Status',
      openFindings: 'Offene Mängel',
      empty: 'Noch keine SiFa-Begehungen',
      emptyHint: 'Mit „Begehung starten“ die erste Begehung hier anlegen.',
      emptyReadOnly: 'Angelegte SiFa-Begehungen erscheinen hier.',
    },
    start: {
      action: 'Begehung starten',
      title: 'Begehung starten',
      planTitle: 'Begehung planen',
      description: 'Liegt das Datum in der Zukunft, wird die Begehung geplant.',
      submit: 'Starten',
      plan: 'Planen',
      started: 'Begehung gestartet',
      planned: 'Begehung geplant',
      copyFailed: 'Die Begehung ist angelegt, die Mängel ließen sich nicht übernehmen.',
      offlineUnavailable:
        'Ohne Verbindung lassen sich Begehungen nur anlegen, wenn das Gerät SiFa-Begehungen offline hält.',
      object: 'Objekt',
      objectPlaceholder: 'Objekt auf diesem Gerät wählen',
      objectHint: 'Die Betriebsstätte. Projekt und Kunde ergeben sich aus dem Objekt.',
      projectObjectHint: 'Eines der Objekte des Projekts.',
      projectObjectPlaceholder: 'Objekt des Projekts wählen',
      noObjects: 'Das Projekt hat keine Objekte',
      noObjectsHint:
        'Eine Begehung findet an einem Objekt statt. Ordne dem Projekt unter „Objekte“ ein Objekt zu, dann lässt sich die Begehung starten.',
      projectClosed: 'Projekt nicht offen',
      projectClosedHint:
        'Begehungen lassen sich nur in offenen Projekten der eigenen Firma starten, nicht in abgeschlossenen, stornierten oder archivierten.',
      project: 'Projekt',
      projectLoading: 'Projekt wird ermittelt',
      noProject: 'Kein offenes Projekt am Objekt',
      noProjectHint:
        'Eine Begehung gehört immer zu einem Projekt. Ordne das Objekt unter Projekte einem laufenden Projekt zu, dann lässt sich die Begehung starten.',
      projectChoice: 'Am Objekt laufen mehrere offene Projekte. Zu welchem gehört die Begehung?',
      projectPlaceholder: 'Projekt wählen',
      projectRequired: 'Bitte das Projekt der Begehung wählen.',
      otherProject: 'Anderes Projekt wählen',
      customer: 'Kunde',
      noCustomer: 'Am Projekt ist kein Auftraggeber eingetragen.',
      titleField: 'Bezeichnung',
      titleHint: 'Ohne Angabe „Begehung“ mit dem Datum.',
      date: 'Datum',
      dateHint: 'Ein Datum in der Zukunft plant die Begehung.',
      template: 'Allgemeine Angaben',
      templatesUnavailable:
        'Die Vorlagen der Allgemeinen Angaben sind nicht auf dem Gerät. Die Begehung beginnt ohne Fragebogen.',
      copy: 'Mängel aus einer früheren Begehung übernehmen',
      copyFrom: 'Frühere Begehung',
      copyNone: 'Keine übernehmen',
      closedFinding: 'erledigt',
      positiveFinding: 'positiv',
      copyOffline: 'Mängel lassen sich nur mit Verbindung übernehmen.',
    },
    detail: {
      notFound: 'Begehung nicht gefunden',
      notFoundHint: 'Sie wurde gelöscht, oder die Berechtigung fehlt.',
      notOnDevice: 'Begehung nicht auf diesem Gerät',
      notOnDeviceHint:
        'Ohne Verbindung öffnet die App nur Begehungen, die auf dem Gerät liegen. Öffne sie vorher einmal mit Verbindung.',
      onlineOnly: 'Ohne Verbindung nicht verfügbar',
      onlineOnlyHint:
        'In dieser Firma hält dein Gerät nichts offline, etwa weil du als Superadmin in einer anderen Firma als deiner eigenen arbeitest.',
      steps: {
        start: 'Starten',
        complete: 'Protokoll versendet',
        reopen: 'Wieder öffnen',
        startDone: 'Begehung gestartet',
        completeDone: 'Als versendet markiert',
        reopenDone: 'Begehung wieder geöffnet',
      },
      deleted: '„{{title}}“ gelöscht',
      offlineRefused: 'Eine Änderung auf diesem Gerät wurde abgelehnt',
      offlineRefusedHint:
        'Grund: {{reason}}. Details und Verwerfen im Fenster „Synchronisierung“ in der oberen Leiste.',
      completedTitle: 'Protokoll versendet',
      completedSince:
        'Seit {{when}}. Angaben und Anhänge ändern sich erst nach „Wieder öffnen“, Kommentare gehen weiter.',
      plansHint: 'Pläne des Projekts und des Objekts.',
      projectPlans: 'Pläne des Projekts',
      objectPlans: 'Pläne des Objekts',
      createReport: 'Bericht erstellen',
      copySource: '{{date}}: {{title}}',
      noFinding: 'Nach Einschätzung der KI ist das kein Mangel: {{reason}}',
      noPositive: 'Nach Einschätzung der KI ist das nichts Positives: {{reason}}',
      deleteTitle: 'Begehung löschen?',
      deleteDescription: '„{{title}}“ wird gelöscht.',
      deleteHeavy:
        '„{{title}}“ wird mit {{findings}} Mängeln, {{files}} Dateien und den Kommentaren gelöscht. Das lässt sich nicht rückgängig machen.',
      deleteWord: 'LÖSCHEN',
      deleteWordLabel: 'Zum Bestätigen LÖSCHEN eingeben',
      questionnaire: 'Allgemeine Angaben',
      noQuestionnaire: 'Keine Allgemeinen Angaben.',
      attendees: 'Anwesende',
      attendeeName: 'Name',
      attendeeRole: 'Funktion',
      addAttendee: 'Person hinzufügen',
      attendeeRow: 'Anwesende Person {{number}}',
      removeAttendee: 'Anwesende Person {{number}} entfernen',
      noAttendees: 'Noch keine Anwesenden.',
      none: 'Keine Angabe.',
      notes: 'Teilnehmer und Bemerkungen',
      participants: 'Teilnehmer',
      participantsHint: 'Weitere Teilnehmer, etwa Betriebsrat oder Betriebsarzt.',
      remarks: 'Bemerkungen',
      reportAttachments: 'Anhänge im Bericht',
      reportAttachmentsHint:
        'PDF-Dateien der Begehung, die hinter den Bericht kommen, in dieser Reihenfolge.',
      noReportAttachments: 'Noch keine Anhänge im Bericht.',
      attachmentNumber: 'Anhang {{number}}',
      moveUp: '„{{name}}“ nach oben',
      moveDown: '„{{name}}“ nach unten',
      removeFromReport: '„{{name}}“ aus dem Bericht nehmen',
      addToReport: '„{{name}}“ anhängen',
      editTitle: 'Begehung bearbeiten',
      inspectors: 'Begeher',
      inspectorsOffline: 'Begeher lassen sich nur mit Verbindung ändern.',
      sections: 'Abschnitte der Begehung',
      tabs: {
        findings: 'Mängel',
        questionnaire: 'Fragebogen',
        protocol: 'Protokoll',
        plans: 'Pläne',
        files: 'Dateien',
        history: 'Verlauf',
      },
      openFindings: '{{count}} offen',
      meta: {
        date: 'Datum',
        object: 'Objekt',
        project: 'Projekt',
        customer: 'Kunde',
        inspectors: 'Begeher',
      },
    },
  },
};
